module.exports = __webpack_public_path__ + "img/CoverStory.5d0818b5.jpg";